<template>
  <div class="choose-land-container1">
    <div class="top-filter-wrapper">
      <div class="select-box">
        <!--  地块编组选择  -->
        <el-select
          v-model="landGroupId"
          multiple
          collapse-tags
          @change="searchLand"
          placeholder="按地块编组筛选"
          style="width: 224px; margin-right: 20px"
        >
          <el-option
            v-for="landGroup in landGroupList"
            :key="landGroup.id"
            :value="landGroup.id"
            :label="landGroup.landGroupName"
          ></el-option>
        </el-select>
        <!--  搜索地块  -->
        <el-input
          v-model="landName"
          clearable
          @input="searchLand"
          placeholder="搜索地块名称"
          style="width: 220px"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <!--  模式切换按钮    -->
      <div class="btns-group">
        <div
          class="list-mode btn"
          :class="{ active: currentMode == 'ListMode' }"
          @click="changeMode('ListMode')"
        >
          列表模式
        </div>
        <div
          class="map-mode btn"
          :class="{ active: currentMode == 'MapMode' }"
          @click="changeMode('MapMode')"
        >
          地图模式
        </div>
      </div>
    </div>
    <!--  中间模式组件切换，组件切换使用 show 的方式，是为了地图不重复渲染    -->
    <div class="mode-wrapper">
      <transition name="el-fade-in-linear">
        <!--        <component :is="currentMode"></component>-->
        <list-mode v-show="currentMode == 'ListMode'"></list-mode>
      </transition>
      <transition name="el-fade-in-linear">
        <map-mode ref="mapComp" :show="currentMode == 'MapMode'"></map-mode>
      </transition>
    </div>
    <!--  底部栏  -->
    <div class="footer-action-box">
      <div
        class="all-check"
        :class="{ checked: isSelectAllLand }"
        @click="handleSelectAll"
      >
        <div class="check-icon">
          <i class="iconfont icon-round-check"></i>
        </div>
        <span>全选</span>
      </div>
      <div class="selected-info">
        已选择<span>{{ hadSelectedLandList.length }}</span
        >个地块(共<span>{{ totalAcre }}</span
        >亩)
      </div>
      <el-button
        class="next-btn"
        type="primary"
        :disabled="hadSelectedLandList.length == 0"
        @click="clickNextStep"
        :loading="btnLoading"
        >下一步</el-button
      >

      <div class="selected-info notic-info">
        <img src="@/assets/images/ruralInsurance/tips-icon.png" alt="" />
        注意：穗优险仅支持投保粮田类型地块
      </div>
    </div>
  </div>
</template>

<script>
import ListMode from "./ListMode";
import MapMode from "./MapMode";
import { mapState, mapGetters } from "vuex";
import { getInsureDetail } from "@/api/request/snkd.produce";
import { getStrCharLen, cutStrByCharLen } from "@/utils";
export default {
  components: { ListMode, MapMode },
  data() {
    return {
      landGroupId: [],
      landName: "",
      btnLoading: false,
    };
  },
  watch: {
    landName(val) {
      if (getStrCharLen(val) > 40) {
        this.landName = cutStrByCharLen(val, 20);
      }
    },
  },
  computed: {
    ...mapState("ruralInsure", {
      // cropGroupList: (state) => state.cropGroupSelectList,
      landGroupList: (state) => state.landGroupSelectList,
      filterLandCondition: "filterLandCondition",
      insureId: "insureId",
      currentMode: "showLandMode",
      loading: "landLoading",
      landList: "landList",
    }),
    ...mapGetters("ruralInsure", [
      "hadSelectedLandList",
      "isSelectAllLand",
      "showLandList",
    ]),
    totalAcre() {
      return this.calcLandAcre(this.hadSelectedLandList);
    },
  },
  mounted() {
    // 过滤条件回显
    if (this.filterLandCondition !== null) {
      const { landGroupIdArray, landName } = this.filterLandCondition;
      this.landGroupId = landGroupIdArray;
      this.landName = landName;
    }

    // 从确定列表页返回时，如果当前是地图模式，手动加载一次地图
    if (this.currentMode === "MapMode") {
      this.$refs.mapComp.renderMap();
    }
  },
  methods: {
    searchLand() {
      const searchKey = {
        landGroupIdArray: this.landGroupId,
        landName: this.landName,
      };
      this.$store.commit("ruralInsure/filterLandList", searchKey);
    },
    //计算总面积
    calcLandAcre(list) {
      const countStr = list
        .reduce((total, cur) => total + cur.coLandVO.statisticsLandAcre, 0)
        .toFixed(2);
      return parseFloat(countStr);
    },
    //点击下一步
    async clickNextStep() {
      this.btnLoading = true;
      const res = await getInsureDetail({ id: 2 });
      this.btnLoading = false;
      //  console.log("校验最小面积：", res);
      if (res.respCode == 0) {
        const minInsureLandAcre = res.obj.minInsureLandAcre;
        if (this.totalAcre > minInsureLandAcre) {
          this.$emit("next-step", "VerifyList");
        } else {
          this.$message({
            message: "投保面积不小于" + minInsureLandAcre + "亩",
            type: "warning",
          });
        }
      }
    },
    changeMode(mode) {
      if (this.loading) {
        this.$message({
          message: "地块数据还在加载中",
          type: "warning",
        });
        return false;
      }
      if (mode === "MapMode" && this.landList.length > 1000) {
        this.$message({
          message: "地块数据太多，地图模式暂不可用",
          type: "warning",
        });
        return false;
      }
      this.$store.commit("ruralInsure/changeShowLandMode", mode);
    },
    handleSelectAll() {
      const data = {
        selectStatus: !this.isSelectAllLand,
        showLandList: this.showLandList,
      };
      this.$store.commit("ruralInsure/selectAllLand", data);
      // 全选地块勾选状态同步更新
      if (this.currentMode === "MapMode") {
        this.$refs.mapComp.renderMap();
      }
    },
  },
};
</script>

<style lang="scss">
.choose-land-container1 {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  background: #ffffff;
  .top-filter-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 50px 30px 20px;
    background: #ffffff;
    .btns-group {
      display: flex;
      border: 1px solid $--color-primary;
      height: 36px;
      border-radius: 3px;
      overflow: hidden;
      cursor: pointer;
      .btn {
        width: 63px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 12px;
        background: #ffffff;
        color: $--color-primary;
        &.active {
          background: $--color-primary;
          color: #ffffff;
        }
      }
    }
  }
  .mode-wrapper {
    height: calc(100% - 110px - 67px);
    overflow: hidden;
  }
  .footer-action-box {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 67px;
    background: #ffffff;
    box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    .all-check {
      display: flex;
      margin: 0 32px 0 48px;
      cursor: pointer;
      .check-icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #e5e5e5;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 12px;
        i {
          font-size: 12px;
          color: #ffffff;
          margin: 0;
        }
      }
      span {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
      }
      &.checked {
        .check-icon {
          background: $--color-primary;
          border: 0 none;
        }
        span {
          color: $--color-primary;
        }
      }
    }
    .selected-info {
      font-size: 14px;
      line-height: 20px;
      color: #b2b2b2;
      span {
        color: $--color-primary;
      }
    }
    .notic-info {
      float: right;
      position: absolute;
      right: 3%;
      color: #666666 !important;
      display: flex;
      img {
        width: 20px;
        height: 20px;
        margin-right: 7px;
      }
    }
    .next-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 122px;
    }
  }
}
</style>
